export class TemplateBooleanInspection {
    id = 0;
    inspectionId = 0;
    description = '';
}
